import React from 'react';
import ReactSVG from 'react-svg';
import './main.css';

export default
class Header extends React.Component {
	render(){
		const landing = this.props.isLandingMode;
		return (
			<div className={"header "+(landing ? "landing" : "")}>
				<div class="vid-background-div">
					<video autoPlay muted loop class="vid-background">
						<source src="gfx/background.webm" type="video/webm" />
					</video>
					<div class="vid-background-poster">
						<img src="gfx/background-poster.jpg" />
					</div>
				</div>
				<ReactSVG path="logotype.svg" className="logo" />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Header/index.js